import React, { Component } from 'react'
import {View, StyleSheet, Platform} from 'react-native'
import { JDText, JDImage, JDDevice, JDReactShadowView} from '@jdreact/jdreact-core-lib'
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import PropTypes from 'prop-types'
import { imgProcess } from '../utils/tools'

import maskBg from '../images/detail/mask_bg.png'
import vrImg from '../images/detail/vr.png'
import videoImg from '../images/detail/video.png'

export default class HouseSourceItem extends Component {
	static propTypes = {
		recommendHouseItem: PropTypes.object,
		index: PropTypes.number
	};
	render() {
		const {
			mainPic, // 主图
			title, // 房源标题
			labels, // 标签
			room, hall, structureArea, fitmentType, // 室, 厅, 建筑面积, 装修
			totalPrice, unitPrice, // 总价, 单价
			orientation,plotName,
			vrUrl,videoId
		} = this.props.recommendHouseItem || {};
		const {index} = this.props;
		return (
				<View style={[houseItemStyles.houseBox,index == 0 ? {marginTop: JDDevice.getRpx(0)}:null]}>
					<View style={houseItemStyles.houseImgBox}>
						{!!mainPic && <JDImage source={{uri: imgProcess(mainPic)}} style={houseItemStyles.houseImg}></JDImage>}
						<View style={houseItemStyles.flagWrapper}>
							{
								!!vrUrl && (
									<JDImage source={vrImg} style={houseItemStyles.vrImg}></JDImage>
								)
							}
							{
								!!videoId && (
									<JDImage source={videoImg} style={houseItemStyles.videoImg}></JDImage>
								)
							}
						</View>
					</View>
					<View style={houseItemStyles.houseInfo}>
						<JDText style={houseItemStyles.houseTitle} numberOfLines={2}>{title}</JDText>
						<JDText style={houseItemStyles.featureWrap} numberOfLines={1}>
							<JDText style={houseItemStyles.featureItem}>{room}室{hall}厅/</JDText>
							<JDText style={houseItemStyles.squareWrapper}>
								<JDText style={houseItemStyles.featureItem}>{structureArea}m²</JDText>
								{/* <JDText style={[houseItemStyles.squareMin]}>2</JDText> */}
							</JDText>
							<JDText style={houseItemStyles.featureItem}>/{orientation}/</JDText>
							<JDText style={houseItemStyles.featureItem}>{plotName}</JDText>
						</JDText>
						{
							Array.isArray(labels) && labels.length > 0 && (
								<View style={houseItemStyles.labelWrap}>
									{
										labels.map((label, index) =>{
											if(label === '店长推荐'){
												return <LinearGradient
														colors={['#999fbb', '#b7bdd4','#c3c9db']} // 渐变颜色数组
														start={{ x: 0, y: 0 }} // 渐变起始点坐标
														end={{ x: 1, y: 1 }} // 渐变结束点坐标
														style={ houseItemStyles.desInfoLabelLight} // 样式
														key={'labelItem_' + index}
													>
														<JDText style={{
															color: '#fff',
															fontWeight: 'normal',
															fontFamily: 'PingFang SC',
															fontSize: JDDevice.getRpx(22)}}
														>{label}</JDText>
													</LinearGradient>
											}
											return <JDText style={houseItemStyles.desInfoLabel} key={'labelItem_' + index}>{label}</JDText>
										})
									}
								</View>
							)
						}
						<View style={houseItemStyles.housePrice}>
							{
								totalPrice && (
										<View style={houseItemStyles.totalPriceBox}>
											<JDText style={houseItemStyles.totalPrice}>{totalPrice}</JDText>
											<JDText style={houseItemStyles.priceUnit}>万</JDText>
										</View>
								)
							}
							{
								unitPrice && (
									<View style={houseItemStyles.squareWrapper}>
										<JDText style={houseItemStyles.unitPrice}>{unitPrice}元/m</JDText>
										<JDText style={houseItemStyles.square}>2</JDText>
									</View>
								)
							}
						</View>
					</View>
					{/*阴影背景图片，解决安卓端没有投影的问题*/}
					{/* {
						Platform.OS == 'android' && (
								<JDImage source={maskBg} style={houseItemStyles.bgStyle}></JDImage>
						)
					} */}
				</View>
		)
	}
}
const houseItemStyles = StyleSheet.create({
	houseBox: {
		position: 'relative',
		flexDirection: 'row',
		paddingHorizontal: JDDevice.getRpx(24),
		paddingVertical: JDDevice.getRpx(24),
		...Platform.select({ // 不同的平台执行不同的样式
			ios: {
				// shadowColor: '#000',
				// shadowOffset: {h: 0, w: JDDevice.getRpx(2)}, // ios设置阴影
				// shadowRadius: JDDevice.getRpx(8),
				// shadowOpacity: 0.08
			},
			// android: {
			// 	backgroundColor: "#fff", // 要想elevation有效，必须设置backgroundColor
			// 	elevation: 0.3 // 设置Android机上的阴影
			// },
			web: {
				// boxShadow: '0 2px 8px 0 rgba(0,0,0,0.08)'
			}
		})
	},
	houseImgBox: {
		position: 'relative',
		width: JDDevice.getRpx(220),
		minHeightt: JDDevice.getRpx(163),
	},
	houseImg: {
		width: JDDevice.getRpx(220),
		height: JDDevice.getRpx(163),
		borderRadius: JDDevice.getRpx(12),
	},
	houseInfo: {
		flex:1,
		paddingLeft: JDDevice.getRpx(24),
		backgroundColor: "#fff",
		marginTop: JDDevice.getRpx(-4)
	},
	houseTitle: {
		marginBottom: JDDevice.getRpx(8),
		fontSize: JDDevice.getRpx(30),
		lineHeight: JDDevice.getRpx(36),
		fontFamily: 'PingFang SC',
		fontWeight: "500",
		color: '#1A1A1A'
	},
	labelWrap: {
		marginBottom: JDDevice.getRpx(10),
		flexDirection: 'row',
		flexWrap:'wrap',
		alignItems: 'center',
		// height:JDDevice.getRpx(24),
		lineHeight:JDDevice.getRpx(24),
	},
	desInfoLabel: {
		backgroundColor: '#F6F6F6',
		borderRadius: JDDevice.getRpx(6),
		paddingHorizontal: JDDevice.getRpx(8),
		paddingVertical: JDDevice.getRpx(4),
		marginRight: JDDevice.getRpx(10),
		marginBottom: JDDevice.getRpx(4),
		fontWeight: 'normal',
		fontFamily: 'PingFang SC',
		..._getFontStyle(22, '#999999')
	},
	desInfoLabelLight:{
		paddingHorizontal: JDDevice.getRpx(8),
		paddingVertical: JDDevice.getRpx(4),
		borderRadius: JDDevice.getRpx(6),
		marginRight: JDDevice.getRpx(10),
		marginBottom: JDDevice.getRpx(4),
	},
	featureWrap: {
		marginBottom: JDDevice.getRpx(14),
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'nowrap',
		height:JDDevice.getRpx(28),
		lineHeight:JDDevice.getRpx(28),
		fontSize: JDDevice.getRpx(11)
	},
	featureItem: {
		fontWeight:'normal',
		flexShrink:0,
		..._getFontStyle(22, '#555555')
	},
	housePrice: {
		flexDirection: 'row',
		alignItems: 'baseline',
	},
	totalPriceBox: {
		flexDirection: 'row',
		alignItems: 'baseline',
		marginRight: JDDevice.getRpx(15),
		zIndex: 30,
	},
	totalPrice: {
		..._getFontStyle(32, '#FA2C19'),
		fontWeight: 'normal',
		fontFamily: 'JDZhengHT-Regular',
	},
	priceUnit: {
		..._getFontStyle(28, '#FA2C19'),
		fontWeight: '500',
		...Platform.select({
			android: {
				lineHeight: JDDevice.getRpx(36)
			}
		})
	},
	unitPrice: {
		fontWeight:'normal',
		fontFamily: 'PingFang SC',
		..._getFontStyle(24, '#999999')
	},
	bgStyle: {
		position: 'absolute',
		top: -JDDevice.getRpx(8),
		left: -JDDevice.getRpx(8),
		width: JDDevice.getRpx(708),
		height: JDDevice.getRpx(232),
		zIndex: -1
	},
	// 标签wrapper
	flagWrapper: {
		position: 'absolute',
		top: JDDevice.getRpx(111),
		flexDirection: 'row',
	},
	vrImg: {
		width: JDDevice.getRpx(36),
		height: JDDevice.getRpx(36),
		marginLeft: JDDevice.getRpx(16)
	},
	videoImg: {
		width: JDDevice.getRpx(36),
		height: JDDevice.getRpx(36),
		marginLeft: JDDevice.getRpx(12)
	},
	squareWrapper:{
		flexDirection: 'row'
	},
	// 平方
	squareMin:{ 
		top: -JDDevice.getRpx(4),
		fontSize: JDDevice.getRpx(16),
		position:'relative',
		color:'#999',
		transform: [{ scale: .8 }]
	},
	square:{
		top: JDDevice.getRpx(0),
		fontSize: JDDevice.getRpx(16),
		position:'relative',
		color:'#999999',
		transform: [{ scale: .8 }]
	},
	// line
	bottomLine:{
		width:'100%',
		height:0,
		borderBottomWidth:JDDevice.getRpx(1),
		borderStyle:'solid',
		borderColor:'rgba(0,0,0,0.08)',
		// transform:scaleY()
	}
});
function _getFontStyle(size, color) {
	return {
		fontSize: JDDevice.getRpx(size),
		color: color,
		fontFamily: 'PingFang SC'
	}
}